import React,{useEffect, useState} from 'react'
import {useDispatch} from "react-redux"
import { useNavigate } from 'react-router-dom';
import axios from 'axios'
import { addkfr } from './redux/actions';

export default function Navbar_left(props) {
  window.onload=async function(){
    if(window.location.pathname==='/playground'){
      document.getElementById("Nl-slide").click()
      document.getElementById('faStop').click()
    }
  window.addEventListener('popstate',function(){
    window.location.reload()
  })
    
  }

  const dispatch=useDispatch()
  const [lmheading,headupd]=useState('Slide effects');
  const navigate=useNavigate()
  var cls1=document.getElementsByClassName('lm-items');
  var cls2=document.getElementsByClassName('txt-itm');
  var arr_lm1it=document.getElementsByClassName('Lmenu1itms'); 
  var clean=(cls1,cls2)=>{
    for(var i=0;i<cls1.length;i++){
      cls1[i].classList='lm-items';
    }
    for(var j=0;j<cls2.length;j++){
      cls2[j].classList='txt-itm';
    }
  }
  // const host='http://localhost:5000'
  const host='https://sclib.onrender.com'
  var headout=()=>{
      document.getElementById('lm-headid').classList.remove('lmhead-close');
      document.getElementById('lm-headid').classList.add('lmhead-open');
      setTimeout(() => {
        document.getElementById('Lmenu1id').classList.remove('Lmenu1-close');
        document.getElementById('Lmenu1id').classList.add('Lmenu1-open');
      }, 500);
  }
  var hdup=(str)=>{
    if(flag===true){
      setTimeout(() => {
        headupd(str);
      }, 500);
      var flag=false;
    }
    else{
      headupd(str);
    }
  }
  const showelm=()=>{
    for(var obj of arr_lm1it){
      obj.classList='Lmenu1itms';
    }
  }
  const hidelm=(ind)=>{
    for(let i=ind;i<arr_lm1it.length;i++){
      arr_lm1it[i].classList.add('hidden');
    }
  }
  const charRepl=(str)=>{
    return  str.map(str => str.replace(new RegExp("-", "g"), "_"));
  }
//   const showSetting=()=>{  document.getElementById('rmitems4').style.display='block'
// }


  const zin_act=async()=>{
    hdup('Zoom-in effects');
    headout();
    clean(cls1,cls2);
    document.getElementById('Nl-zoomin').classList.add("lmitm-chg");
    document.getElementById('inr-txt').classList.add("txtitm-chg");
    document.getElementById('Lmenu2id').style.animation='open 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'
    let names=['zin-left','zin-right','zin-center','zin-top','zin-bottom','zin-top-right','zin-top-left','zin-bottom-right','zin-bottom-left','zin-hor-center','zin-hor-left','zin-hor-right','zin-vert-center','zin-vert-top','zin-vert-bottom']
    props.updt(names);
    showelm();
    hidelm(15);
    showSettings()
    setTimeout(async() => {
      let response=await axios.get(`${host}/ZoomIn`)
      dispatch(addkfr(response))
      props.apiresp(response)
    }, 50);
    props.Nlkeyget(charRepl(names))
    
  }
  const zout_act=async ()=>{
    hdup('Zoom-out effects');
    headout();
    clean(cls1,cls2);
    document.getElementById('Nl-zoomout').classList.add("lmitm-chg");
    document.getElementById('inr-txt2').classList.add("txtitm-chg");
    document.getElementById('Lmenu2id').style.animation='open 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'
    let names=['zout-left','zout-right','zout-center','zout-top','zout-bottom','zout-top-right','zout-top-left','zout-btm-right','zout-bottom-left','zout-hor-center','zout-hor-left','zout-hor-right','zout-vert-center','zout-vert-top','zout-vert-btm']
    props.updt(names);
    showelm();
    hidelm(15);
    
    
    setTimeout(async() => {
      let response=await axios.get(`${host}/ZoomOut`)
      dispatch(addkfr(response))
      props.apiresp(response)
    }, 50);
    props.Nlkeyget(charRepl(names))
  }
  const showSettings=()=>{  
    setTimeout(() => {
      const elem=document.getElementById('rmitems4')
      if(elem) elem.style.display='flex'
    }, 100);
  }
  const slide_act=async()=>{
    hdup('Slide effects');
    headout();
    clean(cls1,cls2);
    document.getElementById('Nl-slide').classList.add("lmitm-chg");
    document.getElementById('inr-txt3').classList.add("txtitm-chg");
    document.getElementById('Lmenu2id').style.animation='open 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'
    let names=['sl-left','sl-right','sl-top','sl-bottom','sl-top-right','sl-top-left','sl-bottom-right','sl-bottom-left','sl-bk-center','sl-bk-top','sl-bk-tr','sl-bk-right','sl-bk-br','sl-bk-bottom','sl-bk-bl','sl-bk-left','sl-bk-tl','sl-fwd-center','sl-fwd-top','sl-fwd-tr','sl-fwd-right','sl-fwd-br','sl-fwd-bottom','sl-fwd-bl','sl-fwd-left','sl-fwd-tl','sl-rot-hor-top','sl-rot-hor-t-bk','sl-rot-hor-t-fwd','sl-rot-ver-right','sl-rot-ver-r-bck','sl-rot-ver-r-fwd','sl-rot-hor-btm','sl-rot-hor-b-bk','sl-rot-hor-b-fwd','sl-rot-ver-left','sl-rot-ver-t-bck','sl-rot-ver-t-fwd']
    props.updt(names);
    showelm();
    hidelm(38);
    showSettings()
    
    setTimeout(async() => {
      let response=await axios.get(`${host}/slide`)
      dispatch(addkfr(response))
      props.apiresp(response)
    }, 50);
    props.Nlkeyget(charRepl(names))
  }
  const slideIn_act=async()=>{
    hdup('SlideIn effects');
    headout();
    clean(cls1,cls2);
    document.getElementById('Nl-slideIn').classList.add("lmitm-chg");
    document.getElementById('inr-txt19').classList.add("txtitm-chg");
    document.getElementById('Lmenu2id').style.animation='open 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'
    let names=[
'Sl-in-top',
'Sl-in-tr',
'Sl-in-rig',
'Sl-in-br',
'Sl-in-btm',
'Sl-in-bl',
'Sl-in-left',
'Sl-in-tl',
'Sl-in-fwd-center',
'Sl-in-fwd-top',
'Sl-in-fwd-tr',
'Sl-in-fwd-rig',
'Sl-in-fwd-br',
'Sl-in-fwd-btm',
'Sl-in-fwd-bl',
'Sl-in-fwd-left',
'Sl-in-fwd-tl',
'Sl-in-bck-center',
'Sl-in-bck-top',
'Sl-in-bck-tr',
'Sl-in-bck-rig',
'Sl-in-bck-br',
'Sl-in-bck-btm',
'Sl-in-bck-bl',
'Sl-in-bck-left',
'Sl-in-bck-tl',
'Sl-in-blr-top',
'Sl-in-blr-tr',
'Sl-in-blr-rig',
'Sl-in-blr-br',
'Sl-in-blr-btm',
'Sl-in-blr-bl',
'Sl-in-blr-left',
'Sl-in-blr-tl',
'Sl-in-el-top-fwd',
'Sl-in-el-top-bck',
'Sl-in-el-rig-fwd',
'Sl-in-el-rig-bck',
'Sl-in-el-btm-fwd',
'Sl-in-el-btm-bck',
'Sl-in-el-left-fwd',
'Sl-in-el-left-bck'
    ]
    props.updt(names);
    showelm();
    hidelm(42);
    showSettings()
    
   setTimeout(async() => {
     let response=await axios.get(`${host}/slideIn`)
     dispatch(addkfr(response))
     props.apiresp(response)
   }, 50);
    props.Nlkeyget(charRepl(names))
  }
  const slideOut_act=async()=>{
    hdup('SlideOut effects');
    headout();
    clean(cls1,cls2);
    document.getElementById('Nl-slideOut').classList.add("lmitm-chg");
    document.getElementById('inr-txt20').classList.add("txtitm-chg");
    document.getElementById('Lmenu2id').style.animation='open 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'
    let names=[
'Sl-out-top',
'Sl-out-tr',
'Sl-out-rig',
'Sl-out-br',
'Sl-out-btm',
'Sl-out-bl',
'Sl-out-left',
'Sl-out-tl',
'Sl-out-bck-center',
'Sl-out-bck-top',
'Sl-out-bck-tr',
'Sl-out-bck-rig',
'Sl-out-bck-br',
'Sl-out-bck-btm',
'Sl-out-bck-bl',
'Sl-out-bck-left',
'Sl-out-bck-tl',
'Sl-out-fwd-center',
'Sl-out-fwd-top',
'Sl-out-fwd-tr',
'Sl-out-fwd-rig',
'Sl-out-fwd-br',
'Sl-out-fwd-btm',
'Sl-out-fwd-bl',
'Sl-out-fwd-left',
'Sl-out-fwd-tl',
'Sl-out-blr-top',
'Sl-out-blr-tr',
'Sl-out-blr-rig',
'Sl-out-blr-br',
'Sl-out-blr-btm',
'Sl-out-blr-bl',
'Sl-out-blr-left',
'Sl-out-blr-tl',
'Sl-out-el-top-bck',
'Sl-out-el-top-fwd',
'Sl-out-el-rig-bck',
'Sl-out-el-rig-fwd',
'Sl-out-el-btm-bck',
'Sl-out-el-btm-fwd',
'Sl-out-el-left-bck',
'Sl-out-el-left-fwd'
    ]
    props.updt(names);
    showelm();
    hidelm(42);
    showSettings()
    
    setTimeout(async() => {
      let response=await axios.get(`${host}/slideOut`)
      dispatch(addkfr(response))
      props.apiresp(response)
    }, 50);
    props.Nlkeyget(charRepl(names))
  }


  const flip_act=async()=>{
    hdup('Flip effects');
    headout();
    clean(cls1,cls2);
    document.getElementById('Nl-flip').classList.add("lmitm-chg");
    document.getElementById('inr-txt4').classList.add("txtitm-chg");
    document.getElementById('Lmenu2id').style.animation='open 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'
    let names=['Fhor-btm','Fhor-top','Fhor-bk','Fhor-fwd','Fvert-right','Fvert-left','Fvert-bk','Fvert-fwd','Fedge-1-tr','Fedge-1-bl','Fedge-1-bk','Fedge-1-fwd','Fedge-2-br','Fedge-2-tl','Fedge-2-bk','Fedge-2-fwd','F2-hor-top-1','F2-hor-top-2','F2-hor-top-bck','F2-hor-top-fwd','F2-ver-rig-1','F2-ver-rig-2','F2-ver-rig-bck','F2-ver-rig-fwd','F2-hor-btm-1','F2-hor-btm-2','F2-hor-btm-bck','F2-hor-btm-fwd','F2-ver-left-1','F2-ver-left-2','F2-ver-left-bck','F2-ver-left-fwd','Fzoom-out-hor','Fzoom-in-hor','Fzoom-in-ver','Fzoom-out-ver','Fzm-out-edge-1','Fzm-in-edge-1','Fzm-out-edge-2','Fzm-in-edge-2']
    props.updt(names);
    showelm();
    hidelm(40);
    showSettings()
    
    setTimeout(async() => {
      let response=await axios.get(`${host}/flip`)
      dispatch(addkfr(response))
      props.apiresp(response)
    }, 50);
    props.Nlkeyget(charRepl(names))
  }
  const flipIn_act=async()=>{
    hdup('FlipIn effects');
    headout();
    clean(cls1,cls2);
    document.getElementById('Nl-flipIn').classList.add("lmitm-chg");
    document.getElementById('inr-txt21').classList.add("txtitm-chg");
    document.getElementById('Lmenu2id').style.animation='open 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'
    let names=[
'Fin-hor-btm',
'Fin-hor-top',
'Fin-ver-rig',
'Fin-ver-left',
'Fin-dg-1-tr',
'Fin-dg-1-bl',
'Fin-dg-2-tl',
'Fin-dg-2-br',
'Sin-vert',
'Sin-hor',
'Sin-dgonal-1',
'Sin-dgonal-2'
    ]
    props.updt(names);
    showelm();
    hidelm(40);
    showSettings()
    
    setTimeout(async() => {
      let response=await axios.get(`${host}/flipSlitIn`)
      dispatch(addkfr(response))
      props.apiresp(response)
    }, 50);
    props.Nlkeyget(charRepl(names))
  }
  const flipOut_act=async()=>{
    hdup('FlipOut effects');
    headout();
    clean(cls1,cls2);
    document.getElementById('Nl-flipOut').classList.add("lmitm-chg");
    document.getElementById('inr-txt22').classList.add("txtitm-chg");
    document.getElementById('Lmenu2id').style.animation='open 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'
    let names=[
'Fout-hor-top',
'Fout-hor-btm',
'Fout-ver-left',
'Fout-ver-rig',
'Fout-dg-1-tr',
'Fout-dg-1-bl',
'Fout-dg-2-tl',
'Fout-dg-2-br',
'Sout-vert',
'Sout-hor',
'Sout-dgonal-1',
'Sout-dgonal-2'
    ]
    props.updt(names);
    showelm();
    hidelm(40);
    showSettings()
    
    setTimeout(async() => {
      let response=await axios.get(`${host}/flipSlitOut`)
      dispatch(addkfr(response))
      props.apiresp(response)
    }, 50);
    props.Nlkeyget(charRepl(names))
  }
  const rotate_act=async()=>{
    hdup('Rotate effects');
    headout();
    clean(cls1,cls2);
    document.getElementById('Nl-rotate').classList.add("lmitm-chg");
    document.getElementById('inr-txt5').classList.add("txtitm-chg");
    document.getElementById('Lmenu2id').style.animation='open 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'
    let names=['Rcenter','Rtop','Rtop-right','Rright','Rbtm-right','Rbottom','Rbtm-left','Rleft','Rtop-left','Rhor-center','Rhor-top','Rhor-btm','Rvert-center','Rvert-left','Rvert-right','Redge-1','Redge-2','Redge-top-rig','Redge-btm-rig','Redge-btm-left','Redge-top-left','Rzoom-out','Rzoom-in','Rzoom-out-hor','Rzoom-in-hor','Rzoom-out-ver','Rzoom-in-ver','Rzm-out-edge-1','Rzm-in-edge-1','Rzm-out-edge-2','Rzm-in-edge-2','R90dg-cw','R90dg-ccw','R90dg-top-cw','R90dg-top-ccw','R90dg-rig-cw','R90dg-rig-ccw','R90dg-br-cw','R90dg-br-ccw','R90dg-btm-cw','R90dg-btm-ccw','R90dg-bl-cw','R90dg-bl-ccw','R90dg-left-cw','R90dg-left-ccw','R90dg-tl-cw','R90dg-tl-ccw','R90dg-hor-fwd','R90dg-hor-bk','R90dg-vert-fwd','R90dg-vert-bk']
    props.updt(names)
    showelm();
    hidelm(51);
    showSettings()
    
    setTimeout(async() => {
      let response=await axios.get(`${host}/rotate`)
      dispatch(addkfr(response))
      props.apiresp(response)
    }, 50);
    props.Nlkeyget(charRepl(names))
  }
  const rotateIn_act=async()=>{
    hdup('RotateIn effects');
    headout();
    clean(cls1,cls2);
    document.getElementById('Nl-rotateIn').classList.add("lmitm-chg");
    document.getElementById('inr-txt23').classList.add("txtitm-chg");
    document.getElementById('Lmenu2id').style.animation='open 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'
    let names=[
'Rin-center',
'Rin-top',
'Rin-tr',
'Rin-right',
'Rin-br',
'Rin-btm',
'Rin-bl',
'Rin-left',
'Rin-tl',
'Rin-hor',
'Rin-ver',
'Rin-diag-1',
'Rin-diag-2',
'Rin-2-cw',
'Rin-2-ccw',
'Rin-2-fwd-cw',
'Rin-2-fwd-ccw',
'Rin-2-bck-cw',
'Rin-2-bck-ccw',
'Rin-2-tr-cw',
'Rin-2-tr-ccw',
'Rin-2-br-cw',
'Rin-2-br-ccw',
'Rin-2-bl-cw',
'Rin-2-bl-ccw',
'Rin-2-tl-cw',
'Rin-2-tl-ccw'
    ]
    props.updt(names)
    showelm();
    hidelm(51);
    showSettings()
    
    setTimeout(async() => {
      let response=await axios.get(`${host}/rotateIn`)
      dispatch(addkfr(response))
      props.apiresp(response)
    }, 50);
    props.Nlkeyget(charRepl(names))
  }
  const rotateOut_act=async()=>{
    hdup('RotateOut effects');
    headout();
    clean(cls1,cls2);
    document.getElementById('Nl-rotateOut').classList.add("lmitm-chg");
    document.getElementById('inr-txt24').classList.add("txtitm-chg");
    document.getElementById('Lmenu2id').style.animation='open 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'
    let names=[
'Rout-center',
'Rout-top',
'Rout-tr',
'Rout-right',
'Rout-br',
'Rout-bottom',
'Rout-bl',
'Rout-left',
'Rout-tl',
'Rout-hor',
'Rout-ver',
'Rout-diag-1',
'Rout-diag-2',
'Rout-2-cw',
'Rout-2-ccw',
'Rout-2-bck',
'Rout-2-fwd',
'Rout-2-tr-cw',
'Rout-2-tr-ccw',
'Rout-2-br-cw',
'Rout-2-br-ccw',
'Rout-2-bl-cw',
'Rout-2-bl-ccw',
'Rout-2-tl-cw',
'Rout-2-tl-ccw'
    ]
    props.updt(names)
    showelm();
    hidelm(51);
    showSettings()
    
    setTimeout(async() => {
      let response=await axios.get(`${host}/rotate`)
      dispatch(addkfr(response))
      props.apiresp(response)
    }, 50);
    props.Nlkeyget(charRepl(names))
  }

  const shade_act=async()=>{
    hdup('Shade effects');
    headout();
    clean(cls1,cls2);
    document.getElementById('Nl-shade').classList.add("lmitm-chg");
    document.getElementById('inr-txt6').classList.add("txtitm-chg");
    document.getElementById('Lmenu2id').style.animation='open 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'
    let names=['shd-center','shd-top','shd-right','shd-btm','shd-left','shd-lr','shd-top-btm','shd-top-rig','shd-btm-rig','shd-btm-left','shd-top-left','shd-2-center','shd-2-top','shd-2-rig','shd-2-btm','shd-2-left','shd-2-lr','shd-2-top-btm','shd-2-top-rig','shd-2-btm-rig','shd-2-btm-left','shd-2-top-left','thd-top-right','thd-btm-right','thd-btm-left','thd-top-left','in-center','in-top','in-right','in-bottom','in-left','in-left-right','in-top-btm','in-top-right','in-btm-right','in-btm-left','in-top-left','in-top-left']
    props.updt(names)
    showelm();
    hidelm(37);
    showSettings()
    
    setTimeout(async() => {
      let response=await axios.get(`${host}/shade`)
      dispatch(addkfr(response))
      props.apiresp(response)
    }, 50);
    props.Nlkeyget(charRepl(names))
  }
  
  const swirlIn_act=async()=>{
    hdup('SwirlIn effects');
    headout();
    clean(cls1,cls2);
    document.getElementById('Nl-swirl').classList.add("lmitm-chg");
    document.getElementById('inr-txt7').classList.add("txtitm-chg");
    document.getElementById('Lmenu2id').style.animation='open 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'
    let names=['swl-in-fwd',
      'swl-in-bck',
      'swl-in-top-fwd',
      'swl-in-top-bck',
      'swl-in-tr-fwd',
      'swl-in-tr-bck',
      'swl-in-rig-fwd',
      'swl-in-rig-bck',
      'swl-in-br-fwd',
      'swl-in-btm-fwd',
      'swl-in-btm-bck',
      'swl-in-bl-fwd',
      'swl-in-bl-bck',
      'swl-in-left-fwd',
      'swl-in-left-bck',
      'swl-in-tl-fwd',
      'swl-in-tl-bck']
    props.updt(names)
    showelm();
    hidelm(17);
    showSettings()
    
    setTimeout(async() => {
      let response=await axios.get(`${host}/swirlIn`)
      dispatch(addkfr(response))
      props.apiresp(response)
    }, 50);
    props.Nlkeyget(charRepl(names))
  }
  const swirlOut_act=async()=>{
    hdup('SwirlOut effects');
    headout();
    clean(cls1,cls2);
    document.getElementById('Nl-swirlOut').classList.add("lmitm-chg");
    document.getElementById('inr-txt25').classList.add("txtitm-chg");
    document.getElementById('Lmenu2id').style.animation='open 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'
    let names=[
'Swout-bck',
'Swout-fwd',
'Swout-top-bck',
'Swout-top-fwd',
'Swout-tr-bck',
'Swout-tr-fwd',
'Swout-rig-bck',
'Swout-rig-fwd',
'Swout-br-bck',
'Swout-br-fwd',
'Swout-btm-bck',
'Swout-btm-fwd',
'Swout-bl-bck',
'Swout-bl-fwd',
'Swout-left-bck',
'Swout-left-fwd',
'Swout-tl-bck',
'Swout-tl-fwd'
    ]
    props.updt(names)
    showelm();
    hidelm(17);
    showSettings()
    
   setTimeout(async() => {
     let response=await axios.get(`${host}/swirlOut`)
     dispatch(addkfr(response))
     props.apiresp(response)
   }, 50);
    props.Nlkeyget(charRepl(names))
  }
  const fadein_act=async()=>{
    hdup('FadeIn effects');
    headout();
    clean(cls1,cls2);
    document.getElementById('Nl-fade').classList.add("lmitm-chg");
    document.getElementById('inr-txt9').classList.add("txtitm-chg");
    document.getElementById('Lmenu2id').style.animation='open 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'
    let names=[
'fade-in',
'fade-in-fwd',
'fade-in-bck',
'fade-in-top',
'fade-in-tr',
'fade-in-right',
'fade-in-br',
'fade-in-btm',
'fade-in-bl',
'fade-in-left',
'fade-in-tl',
'puff-in-center',
'puff-in-top',
'puff-in-tr',
'puff-in-right',
'puff-in-br',
'puff-in-btm',
'puff-in-bl',
'puff-in-left',
'puff-in-tl',
'puff-in-hor',
'puff-in-ver',
'flicker-in-1',
'flicker-in-2']
    props.updt(names)
    showelm();
    hidelm(24);
    showSettings()
    
    setTimeout(async() => {
      let response=await axios.get(`${host}/fadeIn`)
      dispatch(addkfr(response))
      props.apiresp(response)
    }, 50);
    props.Nlkeyget(charRepl(names))
  }
  const fadeout_act=async()=>{
    hdup('FadeOut effects');
    headout();
    clean(cls1,cls2);
    document.getElementById('Nl-fadeOut').classList.add("lmitm-chg");
    document.getElementById('inr-txt26').classList.add("txtitm-chg");
    document.getElementById('Lmenu2id').style.animation='open 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'
    let names=[
'fade-out',
'fade-out-bck',
'fade-out-fwd',
'fade-out-top',
'fade-out-tr',
'fade-out-right',
'fade-out-br',
'fade-out-btm',
'fade-out-bl',
'fade-out-left',
'fade-out-tl',
'puff-out-center',
'puff-out-top',
'puff-out-tr',
'puff-out-right',
'puff-out-br',
'puff-out-btm',
'puff-out-bl',
'puff-out-left',
'puff-out-tl',
'puff-out-hor',
'puff-out-ver',
'flicker-out-1',
'flicker-out-2'
    ]
    props.updt(names)
    showelm();
    hidelm(24);
    showSettings()
    
   setTimeout(async() => {
     let response=await axios.get(`${host}/fadeOut`)
     dispatch(addkfr(response))
     props.apiresp(response)
   }, 50);
    props.Nlkeyget(charRepl(names))
  }
  const tilt_act=async()=>{
    hdup('Tilt effects');
    headout();
    clean(cls1,cls2);
    document.getElementById('Nl-tilt').classList.add("lmitm-chg");
    document.getElementById('inr-txt16').classList.add("txtitm-chg");
    document.getElementById('Lmenu2id').style.animation='open 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'
    let names=[
      'tilt-in-top-1',
      'tilt-in-top-2',
      'tilt-in-tr',
      'tilt-in-right-1',
      'tilt-in-right-2',
      'tilt-in-br',
      'tilt-in-bottom-1',
      'tilt-in-bottom-2',
      'tilt-in-bl',
      'tilt-in-left-1',
      'tilt-in-left-2',
      'tilt-in-tl',
      'tilt-in-fwd-tr',
      'tilt-in-fwd-br',
      'tilt-in-fwd-bl',
      'tilt-in-fwd-tl'
    ]
    props.updt(names)
    showelm();
    hidelm(16);
    showSettings()
    
    setTimeout(async() => {
      let response=await axios.get(`${host}/tilt`)
      dispatch(addkfr(response))
      props.apiresp(response)
    }, 50);
    props.Nlkeyget(charRepl(names))
  }
  const bouncein_act=async()=>{
    hdup('BounceIn effects');
    headout();
    clean(cls1,cls2);
      document.getElementById('Nl-bounceRollin').classList.add("lmitm-chg");
      document.getElementById('inr-txt18').classList.add("txtitm-chg");
      document.getElementById('Lmenu2id').style.animation='open 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'
    let names=[
      'bnc-in-top',
      'bnc-in-rig',
      'bnc-in-btm',
      'bnc-in-left',
      'bnc-in-fwd',
      'bnc-in-bck',
      'roll-in-left',
      'roll-in-top',
      'roll-in-rig',
      'roll-in-btm',
      'roll-in-blr-left',
      'roll-in-blr-top',
      'roll-in-blr-rig',
      'roll-in-blr-btm'
    ]
      props.updt(names)
    showelm();
    hidelm(14);
    showSettings()
    
    setTimeout(async() => {
      let response=await axios.get(`${host}/bounceRollIn`)
      dispatch(addkfr(response))
      props.apiresp(response)
    }, 50);
    props.Nlkeyget(charRepl(names))
  }
  const bounceout_act=async()=>{
    hdup('BounceOut effects');
    headout();
    clean(cls1,cls2);
    document.getElementById('Nl-bounceRollOut').classList.add("lmitm-chg");
    document.getElementById('inr-txt27').classList.add("txtitm-chg");
    document.getElementById('Lmenu2id').style.animation='open 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'
    let names=[
'bnc-out-top',
'bnc-out-rig',
'bnc-out-btm',
'bnc-out-left',
'bnc-out-bck',
'bnc-out-fwd',
'roll-out-left',
'roll-out-top',
'roll-out-rig',
'roll-out-btm',
'roll-out-blr-left',
'roll-out-blr-top',
'roll-out-blr-rig',
'roll-out-blr-btm'
    ]
    props.updt(names)
    showelm();
    hidelm(14);
    showSettings()
    
    setTimeout(async() => {
      let response=await axios.get(`${host}/bounceRollOut`)
      dispatch(addkfr(response))
      props.apiresp(response)
    }, 50);
    props.Nlkeyget(charRepl(names))
  }
  const focus_act=async()=>{
    hdup('Focus effects');
    headout();
    clean(cls1,cls2);
    document.getElementById('Nl-textFocus').classList.add("lmitm-chg");
    document.getElementById('inr-txt8').classList.add("txtitm-chg");
    document.getElementById('Lmenu2id').style.animation='open 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'
    let names=[
      'text-focus-in',
      'focus-in-exp',
      'focus-in-exp-fwd',
      'focus-in-cont',
      'focus-in-cont-bck',
      'text-blur-out',
      'blur-out-cont',
      'blur-out-cont-bck',
      'blur-out-exp',
      'blur-out-exp-fwd',
      'text-flk-in-glow',
      'text-flk-out-glow'
    ]
    props.updt(names)
    showelm();
    hidelm(12);
    showSettings()
    
    setTimeout(async() => {
      let response=await axios.get(`${host}/focus`)
      dispatch(addkfr(response))
      props.apiresp(response)
    }, 50);
    props.Nlkeyget(charRepl(names))
  }
  const trackin_act=async()=>{
    hdup('TrackIn effects');
    headout();
    clean(cls1,cls2);
    document.getElementById('Nl-trackIn').classList.add("lmitm-chg");
    document.getElementById('inr-txt10').classList.add("txtitm-chg");
    document.getElementById('Lmenu2id').style.animation='open 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'
    let names=[
      'trk-in-exp',
      'trk-in-exp-fwd',
      'trk-in-exp-fwd-top',
      'trk-in-exp-fwd-btm',
      'trk-in-cont',
      'trk-in-cont-bck',
      'trk-in-cont-bck-top',
      'trk-in-cont-bck-btm'
    ]
    props.updt(names)
    showelm();
    hidelm(8);
    showSettings()

    setTimeout(async() => {
      let response=await axios.get(`${host}/trackIn`)
      dispatch(addkfr(response))
      props.apiresp(response)
    }, 50);
    props.Nlkeyget(charRepl(names))
  }
  const trackout_act=async()=>{
    hdup('TrackOut effects');
    headout();
    clean(cls1,cls2);
    document.getElementById('Nl-trackOut').classList.add("lmitm-chg");
    document.getElementById('inr-txt11').classList.add("txtitm-chg");
    document.getElementById('Lmenu2id').style.animation='open 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'
    let names=[
      'trk-out-cont',
      'trk-out-cont-bck',
      'trk-out-cont-bck-top',
      'trk-out-cont-bck-btm',
      'trk-out-exp',
      'trk-out-exp-fwd',
      'trk-out-exp-fwd-top',
      'trk-out-exp-fwd-btm'
    ]
    props.updt(names)
    showelm();
    hidelm(8);
    showSettings()

    setTimeout(async() => {
      let response=await axios.get(`${host}/trackOut`)
      dispatch(addkfr(response))
      props.apiresp(response)
    }, 50);
    props.Nlkeyget(charRepl(names))
  }
  const shadow_act=async()=>{
    hdup('Shadow effects');
    headout();
    clean(cls1,cls2);
    document.getElementById('Nl-shadowDrop').classList.add("lmitm-chg");
    document.getElementById('inr-txt15').classList.add("txtitm-chg");
    document.getElementById('Lmenu2id').style.animation='open 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'
    let names=[
      'txt-sh-drop-center',
      'txt-sh-drop-top',
      'txt-sh-drop-tr',
      'txt-sh-drop-rig',
      'txt-sh-drop-br',
      'txt-sh-drop-btm',
      'txt-sh-drop-bl',
      'txt-sh-drop-left',
      'txt-sh-drop-tl',
      'txt-sh-pop-top',
      'txt-sh-pop-tr',
      'txt-sh-pop-rig',
      'txt-sh-pop-br',
      'txt-sh-pop-btm',
      'txt-sh-pop-bl',
      'txt-sh-pop-left',
      'txt-sh-pop-tl',
      'txt-pop-up-top',
      'txt-pop-up-tr',
      'txt-pop-up-rig',
      'txt-pop-up-br',
      'txt-pop-up-btm',
      'txt-pop-up-bl',
      'txt-pop-up-left',
      'txt-pop-up-tl'
    ]
    props.updt(names)
    showelm();
    hidelm(25);
    showSettings()
    
    setTimeout(async() => {
      let response=await axios.get(`${host}/shadow`)
      dispatch(addkfr(response))
      props.apiresp(response)
    }, 50);
    props.Nlkeyget(charRepl(names))
  }
  const shine_act=async()=>{
    hdup('Attention effects');
    headout();
    clean(cls1,cls2);
    document.getElementById('Nl-shine').classList.add("lmitm-chg");
    document.getElementById('inr-txt17').classList.add("txtitm-chg");
    document.getElementById('Lmenu2id').style.animation='open 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both'
    let names=[
      'vibrate-1',
      'vibrate-2',
      'vibrate-3',
      'flicker-1',
      'flicker-2',
      'flicker-3',
      'flicker-4',
      'shake-horizontal',
      'shake-vertical',
      'shake-lr',
      'shake-top',
      'shake-tr',
      'shake-right',
      'shake-br',
      'shake-bottom',
      'shake-bl',
      'shake-left',
      'shake-tl',
      'jello-horizontal',
      'jello-vertical',
      'jello-diagonal-1',
      'jello-diagonal-2',
      'wobble-hor-bottom',
      'wobble-hor-top',
      'wobble-ver-left',
      'wobble-ver-right',
      'bounce-top',
      'bounce-bottom',
      'bounce-left',
      'bounce-right',
      'heartbeat ',
      'pulsate-bck',
      'pulsate-fwd',
      'ping',
      'blink-1',
      'blink-2'
    ]
    props.updt(names)
    showelm();
    hidelm(25);
    showSettings()
    
    setTimeout(async() => {
      let response=await axios.get(`${host}/attention`)
      dispatch(addkfr(response))
      props.apiresp(response)
    }, 50);
    props.Nlkeyget(charRepl(names))
  }
 
  return (
    <div>
      <div className='lm-head lmhead-open' id="lm-headid">{lmheading}</div>
       <span className="left-menu flex">
            <ul className="l-m">
                <li className="lm-items lmitm-chg" id="Nl-slide" onClick={slide_act}>
                  <img src="./icons/slide.png" alt=""/>
                  <h6 className="txt-itm txtitm-chg" id='inr-txt3'>Slide</h6>
                </li>
                <li className="lm-items" id='Nl-flip' onClick={flip_act}>
                  <img src="./icons/flip.png" alt=""/>
                  <h6 className="txt-itm" id='inr-txt4'>Flip</h6>
                </li>
                <li className="lm-items " id="Nl-zoomin" onClick={zin_act}>
                  <img src="./icons/zoomin.png" alt=""/>
                  <h6 className="txt-itm " id="inr-txt">Zoom<br/>In</h6>
                </li>
                <li className="lm-items" id="Nl-zoomout" onClick={zout_act}>
                  <img src="./icons/zoomout.png" alt=""/>
                  <h6 className="txt-itm" id='inr-txt2'>Zoom<br/>Out</h6>
                </li>
                <li className="lm-items" id='Nl-rotate' onClick={rotate_act}>
                  <img src="./icons/rotate.png" alt=""/>
                  <h6 className="txt-itm" id='inr-txt5'>Rotate</h6>
                  </li>
                <li className="lm-items" id='Nl-shade' onClick={shade_act}>
                  <img src="./icons/shade.png" alt=""/>
                  <h6 className="txt-itm" id='inr-txt6'>Shades</h6>
                </li>
                <li className="lm-items" id='Nl-swirl' onClick={swirlIn_act}>
                  <img src="./icons/swirl.png" alt=""/>
                  <h6 className="txt-itm" id='inr-txt7'>Swirl-in</h6>
                </li>
                <li className="lm-items" id='Nl-textFocus' onClick={focus_act}>
                  <img src="./icons/textFocus.png" alt=""/>
                  <h6 className="txt-itm" id='inr-txt8'>Focus</h6>
                </li>
                <li className="lm-items" id='Nl-fade' onClick={fadein_act}>
                  <img src="./icons/fade.png" alt=""/>
                  <h6 className="txt-itm" id='inr-txt9'>Fade-in</h6>
                </li>
                <li className="lm-items" id='Nl-trackIn' onClick={trackin_act}>
                  <img src="./icons/trackIn.png" alt=""/>
                  <h6 className="txt-itm" id='inr-txt10'>TrackIn</h6>
                </li>
                <li className="lm-items" id='Nl-trackOut' onClick={trackout_act}>
                  <img src="./icons/trackOut.png" alt=""/>
                  <h6 className="txt-itm" id='inr-txt11'>TrackOut</h6>
                </li>
                <li className="lm-items" id='Nl-bkg' onClick={shade_act}>
                  <img src="./icons/bkg.png" alt=""/>
                  <h6 className="txt-itm" id='inr-txt12'>bkg</h6>
                </li>
                <li className="lm-items" id='Nl-color' onClick={shade_act}>
                  <img src="./icons/color.png" alt=""/>
                  <h6 className="txt-itm" id='inr-txt13'>Color</h6>
                </li>
                <li className="lm-items" id='Nl-efcs' onClick={shade_act}>
                  <img src="./icons/efcs.png" alt=""/>
                  <h6 className="txt-itm" id='inr-txt14'>Efcs</h6>
                </li>
                <li className="lm-items" id='Nl-shadowDrop' onClick={shadow_act}>
                  <img src="./icons/shadowDrop.png" alt=""/>
                  <h6 className="txt-itm" id='inr-txt15'>Shadow</h6>
                </li>
                <li className="lm-items" id='Nl-tilt' onClick={tilt_act}>
                  <img src="./icons/tilt.png" alt=""/>
                  <h6 className="txt-itm" id='inr-txt16'>Tilt</h6>
                </li>
                <li className="lm-items" id='Nl-shine' onClick={shine_act}>
                  <img src="./icons/shine.png" alt=""/>
                  <h6 className="txt-itm" id='inr-txt17'>Effects</h6>
                </li>
                <li className="lm-items" id='Nl-bounceRollin' onClick={bouncein_act}>
                  <img src="./icons/bounceRoll.png" alt=""/>
                  <h6 className="txt-itm" id='inr-txt18'>Bounce-in</h6>
                </li>
                <li className="lm-items" id="Nl-slideIn" onClick={slideIn_act}>
                  <img src="./icons/slide.png" alt=""/>
                  <h6 className="txt-itm" id='inr-txt19'>Slide-in</h6>
                </li>
                <li className="lm-items" id="Nl-slideOut" onClick={slideOut_act}>
                  <img src="./icons/slide.png" alt=""/>
                  <h6 className="txt-itm" id='inr-txt20'>Slide-out</h6>
                </li>
                <li className="lm-items" id='Nl-flipIn' onClick={flipIn_act}>
                  <img src="./icons/flip.png" alt=""/>
                  <h6 className="txt-itm" id='inr-txt21'>Flip-in</h6>
                </li>
                <li className="lm-items" id='Nl-flipOut' onClick={flipOut_act}>
                  <img src="./icons/flip.png" alt=""/>
                  <h6 className="txt-itm" id='inr-txt22'>Flip-out</h6>
                </li>
                <li className="lm-items" id='Nl-rotateIn' onClick={rotateIn_act}>
                  <img src="./icons/rotate.png" alt=""/>
                  <h6 className="txt-itm" id='inr-txt23'>Rotate-in</h6>
                </li>
                <li className="lm-items" id='Nl-rotateOut' onClick={rotateOut_act}>
                  <img src="./icons/rotate.png" alt=""/>
                  <h6 className="txt-itm" id='inr-txt24'>Rotate-out</h6>
                </li>
                <li className="lm-items" id='Nl-swirlOut' onClick={swirlOut_act}>
                  <img src="./icons/swirl.png" alt=""/>
                  <h6 className="txt-itm" id='inr-txt25'>Swirl-out</h6>
                </li>
                <li className="lm-items" id='Nl-fadeOut' onClick={fadeout_act}>
                  <img src="./icons/fade.png" alt=""/>
                  <h6 className="txt-itm" id='inr-txt26'>Fade-out</h6>
                </li>
                <li className="lm-items" id='Nl-bounceRollOut' onClick={bounceout_act}>
                  <img src="./icons/bounceRoll.png" alt=""/>
                  <h6 className="txt-itm" id='inr-txt27'>Bounce-out</h6>
                </li>

            </ul>
        </span>
    </div>
  )
}




